import { Flex, Button } from "@chakra-ui/react";

interface QuickQuestionsProps {
  questions: string[];
  onSelect: (question: string) => void;
}

const QuickQuestions: React.FC<QuickQuestionsProps> = ({
  questions,
  onSelect,
}) => {
  return (
    <Flex flexWrap="wrap" justify="center" gap={3} mt={2} w="100%" pb={2}>
      {questions.map((q) => (
        <Button
          key={q}
          bg="white"
          borderRadius="full"
          px={5}
          h="auto"
          minH="36px"
          py={2}
          fontSize="sm"
          fontWeight={700}
          color="#2341DE"
          boxShadow="md"
          whiteSpace="normal"
          textAlign="center"
          w={{ base: "100%", sm: "45%", md: "30%", xl: "18%" }}
          _hover={{ bg: "#F0F4FF" }}
          onClick={() => onSelect(q)}
        >
          {q}
        </Button>
      ))}
    </Flex>
  );
};

export default QuickQuestions;
